import _get from 'lodash/get';

export const getLifecycleState = state => _get(state, 'lifecycle.currentState', '');
